import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import Alert from '@active/react-ui/Alert';
import classNames from 'classnames';
import I18nMessage from './I18nMessage';
import defaultMessageConfig from './messageConfig';
import { autoScrollToTheErrorField } from '../../../shared/utils/commonUtils';

const { error: defaultError } = defaultMessageConfig;

const BuildMessage = ({ message, className }) => {
  const {
    contactSupportLink,
  } = useSelector(state => state.propsData);

  const classes = useMemo(() => {
    return classNames('cui-mg-t-20',
      className,
    );
  }, [ className ]);

  useEffect(() => {
    !!message && autoScrollToTheErrorField();
  }, [ message ]);

  if (message) {
    const { type, contents, values } = message.type && !message.contents
      ? defaultError.default(contactSupportLink) : message; // string or Object

    return (
      <Alert theme="inline" type={type || 'danger'} className={classes}>
        <I18nMessage id={contents || (typeof message === 'string' ? message : '')} values={values}/>
      </Alert>
    );
  }
  return null;
};

export default BuildMessage;
